import { ReactNode } from 'react';
import { Typography, createStyles, makeStyles } from '@material-ui/core';
import AdvanceIcon from 'assets/icons/AdvanceIcon';
import 'index.scss';
import NotificationIconItem from 'assets/icons/NotificationItem';

interface PropTypes {
  type: string;
  title?: string;
  description: React.ReactNode;
  time?: string;
  icon?: ReactNode;
  onClick: any;
}

const useStyle = makeStyles(
  () =>
    createStyles({
      containerNotifications: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      },
      type: {
        fontSize: '16px',
        display: 'block',
        color: '#67B441',
      },
      containerItens: {
        margin: '1rem',
        flexGrow: 1,
      },
      description: {
        fontSize: '13px',
      },
    }),
  { name: 'LayoutOperacionalUserInfo' }
);

const NotificationItem = ({ type, description, icon, onClick }: PropTypes) => {
  const classes = useStyle();

  return (
    <div onClick={onClick} className={classes.containerNotifications}>
      <div>{icon || <NotificationIconItem />}</div>

      <div className={classes.containerItens}>
        <Typography className={classes.type}>{type}</Typography>

        <Typography className={classes.description}>{description}</Typography>
      </div>

      <div>
        <AdvanceIcon
          className='color-primary-main'
          style={{
            width: '20px',
            fontSize: '20px',
          }}
        />
      </div>
    </div>
  );
};

export default NotificationItem;
